import React, { Component } from 'react';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Divider, Loader } from 'semantic-ui-react';
import { Menu, Item, contextMenu } from 'react-contexify';
import ProFeaturesButton from '../Utils/ProFeaturesButton';
// Librairies
import i18n from '../../locales/i18n';
import { isMobile, isMobileOnly } from 'react-device-detect';
import screenfull from 'screenfull';
// Redux
import { connect } from 'react-redux';
import { setFavoriteTools } from '../../actionCreators/usersActions';
import { setButtonState, toggleToolbarExpand } from '../../actionCreators/appActions';
// Ressources
import {
    faArrowsAlt, faBan, faUserHelmetSafety, faBookmark, faChartLine, faCheck, faCircle, faLasso, faClipboard, faClone, faCompress, faVectorPolygon, faCube, faCubes, faCut, faEdit, faExpand,
    faCloudArrowDown, faEye, faHistory, faLayerGroup, faMapMarker, faMapMarkerAlt, faPencilAlt, faPlus, faPrint, faRedo, faSearchLocation, faSquare, faGavel, faTimelineArrow,
    faStar, faSync, faTable, faTimes, faTools, faTrash, faTree, faUndo, faWaveSquare, faBringFront, faTablePicnic, faFlowerTulip, faChartTreeMap, faAnglesLeft, faAnglesRight, faFilePdf, faCircleBookmark, faList,
    faObjectSubtract, faLocationQuestion, faClock,
    faMagnifyingGlass,
    faLock,
    faPenNib,
    faChartScatter3d,
    faRulerTriangle
} from '@fortawesome/pro-solid-svg-icons';
import { faEye as faEyeAlt, faHexagon, faStar as faStarAlt, faMicrochipAi, faCircle as faCircleAlt } from '@fortawesome/pro-regular-svg-icons';
// Utils
import ProjectsUtil from '../../utils/ProjectsUtil';
import RightsUtil from '../../utils/RightsUtil';
import { showToast } from '../../utils/ToastsUtil';

const cancelButton = { icon: faTimes, title: i18n.t("Annuler") };
const confirmButton = { className: 'y6zVAZvi', icon: faCheck, title: `${i18n.t("Valider")}`, shortcut: 'Ctrl+S' };

const historyButtons = {
    cancel: cancelButton,
    undo: { className: 'M4ARbGof', icon: faUndo, title: `${i18n.t("Undo")}`, shortcut: 'Ctrl+Z' },
    redo: { className: 'rvTXjjwb', icon: faRedo, title: `${i18n.t("Redo")}`, shortcut: 'Ctrl+Y' },
    confirm: confirmButton
};

const copyPasteButton = {
    className: 'copy-paste', icon: faClipboard, title: i18n.t("Copier/coller"), isDefault: true, isSelectable: true,
    children: { reset: { icon: faBan, title: i18n.t("Vider la sélection") } }
};
const duplicateButton = { className: 'duplicate', icon: faClone, title: i18n.t("Duplication linéaire"), isSelectable: true };
const copyPastePropertiesButton = { className: 'copy-paste-properties', icon: faList, title: i18n.t("Copier/coller les propriétés"), isSelectable: true };
const dragButton = { className: 'GAKD8nG1', icon: faArrowsAlt, children: historyButtons };
const removeButton = { className: 'kRvocV1O', icon: faTrash, title: i18n.t("Suppression"), children: historyButtons };

class Toolbar extends Component {
    state = {
        buttons: {
            filters: {
                id: 'ymw1sd3w', icon: faMagnifyingGlass, title: `${i18n.t("Rechercher / Filtrer")}`, shortcut: 'Ctrl+Maj+F',
                isVisible: () => ProjectsUtil.canUseTool('filters', this.getToolContext()) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => (!this.props.baseProjectDataLoadingStatus.treesStatus || !this.props.baseProjectDataLoadingStatus.greenSpacesStatus || !this.props.baseProjectDataLoadingStatus.furnituresStatus || !this.props.baseProjectDataLoadingStatus.stationsStatus || !this.props.baseProjectDataLoadingStatus.markersStatus),
                states: [
                    { title: `${i18n.t("Rechercher / Filtrer")}`, shortcut: 'Ctrl+Maj+F' },
                    { title: `${i18n.t("Modifier les filtres")}`, shortcut: 'Ctrl+Maj+F', isActive: true },
                ], isReduxManaged: true
            },
            favoriteTools: {
                icon: faStar, title: i18n.t("Favoris"), isVisible: () => !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction), children: {}
            },
            treeTools: {
                className: 'trees', icon: faTree, title: i18n.t("Outils arbres"), onlyOne: true, isVisible: () => this.props.logged && RightsUtil.canWrite(this.props.rights?.trees) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => !this.props.baseProjectDataLoadingStatus.treesStatus,
                children: {
                    addTree: {
                        id: 'c3rVPSJ2', icon: faPlus, title: `${i18n.t("Ajouter un arbre")}`, atLeastOne: true,
                        children: {
                            addTreeByClick: { icon: faPencilAlt, title: `${i18n.t("Ajouter un arbre")}`, shortcut: 'T', isDefault: true, isSelectable: true },
                            addEmptyTree: { icon: faCircleAlt, title: i18n.t("Ajouter un emplacement vide"), isSelectable: true },
                            addTreeWithGps: { icon: faMapMarker, title: i18n.t("Ajouter un arbre via GPS"), isVisible: () => isMobile },
                            addTreesWithAI: {
                                icon: faMicrochipAi, title: `${i18n.t("Ajouter des arbres via IA")}`, isDisabledInOffline: true, isSelectable: true,
                                isActivatedInSubscription: () => this.props.project?.organization?.subscription?.ai && this.props.activeOrganization?.subscription?.ai
                            },
                        }
                    },
                    copyTrees: {
                        className: 'copy', icon: faClipboard, title: i18n.t("Copie"), atLeastOne: true,
                        children: {
                            copyPasteTrees: copyPasteButton,
                            duplicateTrees: duplicateButton,
                            copyPasteTreeProperties: copyPastePropertiesButton
                        }
                    },
                    modifyTrees: { icon: faList, title: `${i18n.t("Modifier les propriétés des arbres")}` },
                    completeTreesHeight: {
                        icon: faRulerTriangle, title: `${i18n.t("Compléter les hauteurs (LiDAR)")}`, isDisabledInOffline: true,
                        isVisible: () => !isMobileOnly && this.props.showLidar && RightsUtil.canWrite('Dimensions', this.props.rights?.treeCategories || {}),
                        isActivatedInSubscription: () => this.props.project?.organization?.subscription?.lidar && this.props.activeOrganization?.subscription?.lidar
                    },
                    dragTrees: { ...dragButton, title: `${i18n.t("Déplacement")}`, shortcut: 'Maj+M' },
                    removeTrees: { ...removeButton, title: `${i18n.t("Suppression")}`, shortcut: 'Maj+D' }
                }
            },
            greenSpaceTools: {
                className: 'greenSpaces', icon: faFlowerTulip, title: i18n.t("Outils espaces verts"), onlyOne: true, isVisible: () => this.props.logged && RightsUtil.canWrite(this.props.rights?.greenSpaces) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => !this.props.baseProjectDataLoadingStatus.greenSpacesStatus,
                children: {
                    addGreenSpace: {
                        className: 'IlcgK1aE', icon: faPlus, title: i18n.t("Ajouter un espace vert"), atLeastOne: true,
                        children: {
                            addPolygon: { icon: faPencilAlt, title: `${i18n.t("Dessin personnalisé")}`, shortcut: 'G', isDefault: true, isSelectable: true },
                            addLine: { icon: faWaveSquare, title: `${i18n.t("Ligne")}`, shortcut: 'L', isSelectable: true },
                            addRectangle: { className: 'JRR4zY38', icon: faSquare, title: `${i18n.t("Rectangle")}`, shortcut: 'R', isSelectable: true },
                            addCircle: { className: 'bUub0LSp', icon: faCircle, title: `${i18n.t("Cercle")}`, shortcut: 'O', isSelectable: true },
                            addGreenSpacesWithAI: {
                                icon: faMicrochipAi, title: `${i18n.t("Ajouter des massifs arborés via IA")}`, isDisabledInOffline: true, isSelectable: true, isVisible: () => this.props.showLidar,
                                isActivatedInSubscription: () => this.props.project?.organization?.subscription?.ai && this.props.activeOrganization?.subscription?.ai
                            }
                        }
                    },
                    copyGreenSpaces: {
                        className: 'copy', icon: faClipboard, title: i18n.t("Copie"), atLeastOne: true,
                        children: {
                            copyPasteGreenSpaces: copyPasteButton,
                            duplicateGreenSpaces: duplicateButton,
                            copyPasteGreenSpaceProperties: copyPastePropertiesButton
                        }
                    },
                    modifyGreenSpaces: { icon: faList, title: `${i18n.t("Modifier les propriétés des espaces verts")}` },
                    dragGreenSpaces: { ...dragButton, title: `${i18n.t("Déplacement")}`, shortcut: 'Alt+M' },
                    rotateGreenSpaces: { className: 'fpGjuf9z', icon: faSync, title: `${i18n.t("Rotation")}`, shortcut: 'Alt+R', children: historyButtons },
                    editGreenSpaces: { className: 'nmhlobgI', icon: faVectorPolygon, title: `${i18n.t("Redimensionnement")}`, shortcut: 'Alt+E', children: historyButtons },
                    splitGreenSpaces: { className: 'Wv7D7QBU', icon: faCubes, title: `${i18n.t("Division")}`, shortcut: 'Alt+S', children: historyButtons },
                    mergeGreenSpaces: { className: 'HM1Z6QIB', icon: faCube, title: `${i18n.t("Fusion")}`, shortcut: 'Alt+F', children: historyButtons },
                    cutGreenSpaces: { className: 'fzYujGUs', icon: faCut, title: `${i18n.t("Découpage")}`, shortcut: 'Alt+C', children: historyButtons },
                    subtractGreenSpaces: { icon: faObjectSubtract, title: `${i18n.t("Soustraction")}`, children: historyButtons },
                    removeGreenSpaces: { ...removeButton, title: `${i18n.t("Suppression")}`, shortcut: 'Alt+D' }
                }
            },
            stationTools: {
                className: 'stations', icon: faHexagon, title: i18n.t("Outils stations"), onlyOne: true, isVisible: () => this.props.logged && RightsUtil.canWrite(this.props.rights?.stations) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => !this.props.baseProjectDataLoadingStatus.stationsStatus, isDisabledInOffline: true,
                children: {
                    addStation: {
                        className: 'IlcgK1aE', icon: faPlus, title: i18n.t("Ajouter une station"), atLeastOne: true,
                        children: {
                            addPolygon: { icon: faPencilAlt, title: `${i18n.t("Dessin personnalisé")}`, isDefault: true, isSelectable: true },
                            addRectangle: { icon: faSquare, title: `${i18n.t("Rectangle")}`, isSelectable: true },
                            addCircle: { icon: faCircle, title: `${i18n.t("Cercle")}`, isSelectable: true }
                        }
                    },
                    dragStations: { ...dragButton, title: `${i18n.t("Déplacement")}`, shortcut: 'Alt+M' },
                    rotateStations: { className: 'fpGjuf9z', icon: faSync, title: `${i18n.t("Rotation")}`, shortcut: 'Alt+R', children: historyButtons },
                    editStations: { className: 'nmhlobgI', icon: faVectorPolygon, title: `${i18n.t("Redimensionnement")}`, shortcut: 'Alt+E', children: historyButtons },
                    removeStations: { ...removeButton, title: `${i18n.t("Suppression")}`, shortcut: 'Alt+D' }
                }
            },
            furnitureTools: {
                className: 'furnitures', icon: faTablePicnic, title: i18n.t("Outils mobilier urbain"), onlyOne: true, isVisible: () => this.props.logged && RightsUtil.canWrite(this.props.rights?.furnitures) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => !this.props.baseProjectDataLoadingStatus.furnituresStatus,
                children: {
                    addFurniture: { icon: faPlus, title: `${i18n.t("Ajouter un mobilier urbain")}`, shortcut: 'M', isSelectable: true },
                    addFurnitureWithGps: { icon: faMapMarker, title: `${i18n.t("Ajouter un mobilier urbain via GPS")}`, isVisible: () => isMobile },
                    copyFurnitures: {
                        className: 'copy', icon: faClipboard, title: `${i18n.t("Copie")}`, atLeastOne: true,
                        children: {
                            copyPasteFurnitures: copyPasteButton,
                            duplicateFurnitures: duplicateButton,
                            copyPasteFurnitureProperties: copyPastePropertiesButton
                        }
                    },
                    modifyFurnitures: { icon: faList, title: `${i18n.t("Modifier les propriétés des mobiliers")}` },
                    dragFurnitures: { ...dragButton, title: `${i18n.t("Déplacement")}` },
                    removeFurnitures: { ...removeButton, title: `${i18n.t("Suppression")}` }
                }
            },
            markerTools: {
                className: 'markers', icon: faLocationQuestion, title: i18n.t("Outils repères"), onlyOne: true, isVisible: () => this.props.logged && RightsUtil.canWrite(this.props.rights?.markers) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                isLoading: () => !this.props.baseProjectDataLoadingStatus.markersStatus,
                children: {
                    addMarker: { icon: faPlus, title: `${i18n.t("Ajouter un repère")}`, shortcut: 'M', isSelectable: true },
                    addMarker: {
                        icon: faPlus, title: i18n.t("Ajouter un repère"), shortcut: 'M', atLeastOne: true,
                        children: {
                            addMarkerByClick: { icon: faPencilAlt, title: `${i18n.t("Ajouter un repère")}`, shortcut: 'M', isDefault: true, isSelectable: true },
                            addMarkerWithGps: { icon: faMapMarker, title: i18n.t("Ajouter un repère via GPS"), isVisible: () => isMobile },
                            addPolygon: { icon: faPencilAlt, title: `${i18n.t("Dessin personnalisé")}`, isSelectable: true },
                            addRectangle: { icon: faSquare, title: `${i18n.t("Rectangle")}`, isSelectable: true },
                            addCircle: { icon: faCircle, title: `${i18n.t("Cercle")}`, isSelectable: true }
                        }
                    },
                    copyMarkers: {
                        className: 'copy', icon: faClipboard, title: `${i18n.t("Copie")}`, atLeastOne: true,
                        children: {
                            copyPasteMarkers: copyPasteButton,
                            duplicateMarkers: duplicateButton,
                            copyPasteMarkerProperties: copyPastePropertiesButton
                        }
                    },
                    modifyMarkers: { icon: faList, title: `${i18n.t("Modifier les propriétés des repères")}` },
                    dragMarkers: { ...dragButton, title: `${i18n.t("Déplacement")}` },
                    rotateMarkers: { icon: faSync, title: `${i18n.t("Rotation")}`, children: historyButtons },
                    editMarkers: { icon: faVectorPolygon, title: `${i18n.t("Redimensionnement")}`, children: historyButtons },
                    removeMarkers: { ...removeButton, title: `${i18n.t("Suppression")}` }
                }
            },
            table: {
                id: 'W8aOEs9N', icon: faTable, title: `${i18n.t("Tableau de données")}`, shortcut: 'Ctrl+Maj+D',
                isVisible: () => ProjectsUtil.canUseTool('dataTable', this.getToolContext()) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                states: [
                    { title: `${i18n.t("Tableau de données")}`, shortcut: 'Ctrl+Maj+D' },
                    { title: `${i18n.t("Supprimer la surbrillance")}`, shortcut: 'Ctrl+Maj+D', isActive: true },
                ], isReduxManaged: true
            },
            actions: {
                id: 'jugChGsl', key: 'actions', icon: faUserHelmetSafety, title: `${i18n.t("Actions")}`, shortcut: 'Ctrl+Maj+A', isVisible: () => this.props.project && RightsUtil.canRead(this.props.rights?.actions),
                states: [
                    { title: `${i18n.t("Gestion des actions")}`, shortcut: 'Ctrl+Maj+A' },
                    { title: `${i18n.t("Valider les liaisons")}`, shortcut: 'Ctrl+Maj+A', isActive: true },
                ], isReduxManaged: true,
                isActivatedInSubscription: () => this.props.project?.organization?.subscription?.actions && this.props.activeOrganization?.subscription?.actions
            },
            advancedTools: {
                id: 'cSCfLHkG', icon: faTools, title: i18n.t("Autres outils"),
                children: {
                    lidarViewer: {
                        id: 'Lq7dR2xN', key: 'lidar', icon: faChartScatter3d, title: `${i18n.t("Visualisation de données LiDAR")}`, isDisabledInOffline: true,
                        isVisible: () => !isMobileOnly && this.props.showLidar && ProjectsUtil.isUserInProject(this.props.projectCollaborators)
                            && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                        isActivatedInSubscription: () => this.props.project?.organization?.subscription?.lidar && this.props.activeOrganization?.subscription?.lidar
                    },
                    statistics: {
                        id: 'Vp7ZCFyO', icon: faChartLine, title: `${i18n.t("Statistiques")}`, shortcut: 'Ctrl+Maj+S', isVisible: () => (
                            ['statistics', 'charts', 'customCharts'].some(tool => ProjectsUtil.canUseTool(tool, this.getToolContext()))
                            && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction)
                        ),
                        isLoading: () => (!this.props.baseProjectDataLoadingStatus.actionsStatus || !this.props.baseProjectDataLoadingStatus.treesStatus || !this.props.baseProjectDataLoadingStatus.greenSpacesStatus || !this.props.baseProjectDataLoadingStatus.furnituresStatus),
                        states: [
                            { title: `${i18n.t("Statistiques")}`, shortcut: 'Ctrl+Maj+S' },
                            { title: `${i18n.t("Supprimer la surbrillance")}`, shortcut: 'Ctrl+Maj+S', autoSwitch: true, isActive: true },
                        ], isReduxManaged: true
                    },
                    events: {
                        id: 'nogtLGzl', icon: faClock, title: `${i18n.t("Évènements")}`, shortcut: 'Ctrl+Maj+E', isVisible: () => this.props.project && RightsUtil.canRead(this.props.rights?.events),
                        states: [
                            { title: `${i18n.t("Gestion des évènements")}`, shortcut: 'Ctrl+Maj+E' },
                            { title: `${i18n.t("Valider les liaisons")}`, shortcut: 'Ctrl+Maj+E', isActive: true },
                        ], isReduxManaged: true
                    },
                    imageTools: {
                        id: 'bSgMFHyv', icon: faLayerGroup, title: `${i18n.t("Outils calques")}`, onlyOne: true, isVisible: () => RightsUtil.canRead(this.props.rights?.backgroundImages) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                        isLoading: () => !this.props.baseProjectDataLoadingStatus.backgroundImagesStatus,
                        children: {
                            addImage: {
                                icon: faPlus, title: `${i18n.t("Ajouter un calque")}`, shortcut: 'I', isVisible: () => RightsUtil.canWrite(this.props.rights?.backgroundImages),
                                children: {
                                    cancel: cancelButton,
                                    confirm: confirmButton
                                }, isDisabledInOffline: true
                            },
                            showImages: {
                                icon: faEye,
                                state: 0, states: [
                                    { icon: faEye, title: i18n.t("Afficher les calques") },
                                    { icon: faEyeAlt, title: i18n.t("Masquer les calques"), isActive: true }
                                ], autoSwitch: true
                            },
                            orderImages: {
                                icon: faBringFront, title: i18n.t("Gestion"), isVisible: () => RightsUtil.canWrite(this.props.rights?.backgroundImages), isDisabledInOffline: true,
                                children: {
                                    cancel: cancelButton,
                                    confirm: confirmButton
                                }
                            },
                            editImages: { className: '76MiPldt', icon: faEdit, title: i18n.t("Édition"), isVisible: () => RightsUtil.canWrite(this.props.rights?.backgroundImages), children: historyButtons, isDisabledInOffline: true },
                            removeImages: { ...removeButton, isVisible: () => RightsUtil.canWrite(this.props.rights?.backgroundImages), isDisabledInOffline: true }
                        }
                    },
                    offlineArea: {
                        icon: faCloudArrowDown, title: `${i18n.t("Préparer le fond hors-ligne")}`, isDisabledInOffline: true, isSelectable: true,
                        isVisible: () => this.props.hasOfflineBaseLayers && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction)
                    },
                    printer: {
                        id: 'KOmV5Upc', icon: faPrint, title: `${i18n.t("Export cartographique")}`, isDisabledInOffline: true, shortcut: 'Ctrl+Maj+P', isSelectable: true,
                        isVisible: () => !isMobileOnly && RightsUtil.canRead(this.props.rights?.mapExport) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction)
                    },
                    history: {
                        id: 'caMdgjoo', icon: faHistory, title: `${i18n.t("Historique du projet")}`, isDisabledInOffline: true, shortcut: 'Ctrl+Maj+H',
                        states: [
                            { title: `${i18n.t("Historique du projet")}`, isDisabledInOffline: true, shortcut: 'Ctrl+Maj+H' },
                            { title: `${i18n.t("Supprimer la surbrillance")}`, shortcut: 'Ctrl+Maj+H', isActive: true },
                        ], isReduxManaged: true, isVisible: () => this.props.project?.type === 'project' && RightsUtil.canRead(this.props.rights?.projectHistory)
                    },
                    legend: {
                        title: i18n.t("Légende"), isVisible: () => !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                        state: 0, states: [
                            { icon: faChartTreeMap, title: `${i18n.t("Afficher la légende")}`, isActive: true },
                            { icon: faChartTreeMap, title: i18n.t("Masquer la légende") }
                        ], isReduxManaged: true
                    },
                    references: {
                        id: 'Ueu5GQ3h', isVisible: () => this.props.project && this.publicFields?.main.references && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                        icon: faBookmark, title: i18n.t("Afficher l'outil des références"), isSelectable: true
                    },
                    searchLocation: {
                        icon: faSearchLocation, title: i18n.t("Outil de recherche"),
                        state: 0, states: [
                            { title: i18n.t("Afficher l'outil de recherche") },
                            { title: i18n.t("Masquer l'outil de recherche"), isActive: true }
                        ], autoSwitch: true, isDisabledInOffline: true
                    },
                    geolocation: {
                        icon: faMapMarkerAlt, title: i18n.t("Géolocalisation"),
                        states: [
                            { title: i18n.t("Afficher ma localisation") },
                            { title: i18n.t("Masquer ma localisation"), isActive: true }
                        ], isReduxManaged: true
                    },
                    lasso: {
                        icon: faLasso, title: i18n.t("Lasso"), isVisible: () => !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                        states: [
                            { title: i18n.t("Activer l'outil lasso") },
                            { title: i18n.t("Désactiver l'outil lasso"), isActive: true }
                        ], isReduxManaged: true
                    },
                    fullscreen: {
                        title: i18n.t("Plein écran"), isVisible: () => screenfull.isEnabled,
                        states: [
                            { icon: faExpand, title: i18n.t("Activer le mode plein écran") },
                            { icon: faCompress, title: i18n.t("Désactiver le mode plein écran"), isActive: true }
                        ], isReduxManaged: true
                    },
                    timeline: {
                        icon: faTimelineArrow, title: `${i18n.t("Ligne du temps")}`, state: 0, states: [
                            { title: `${i18n.t("Afficher la ligne du temps")}` },
                            { title: i18n.t("Masquer la ligne du temps"), isActive: true }
                        ], isReduxManaged: true,
                        isVisible: () => !isMobileOnly && RightsUtil.canRead(this.props.rights?.timeline) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction), isDisabledInOffline: true,
                        isLoading: () => (!this.props.baseProjectDataLoadingStatus.treesStatus || !this.props.baseProjectDataLoadingStatus.greenSpacesStatus || !this.props.baseProjectDataLoadingStatus.furnituresStatus || !this.props.baseProjectDataLoadingStatus.stationsStatus || !this.props.baseProjectDataLoadingStatus.markersStatus),
                    }
                }
            },
            adminTools: {
                icon: faGavel, title: i18n.t("Outils d'administration"), isVisible: () => this.props.project && ['Admin', 'Dev'].includes((this.props.logged && this.props.activeOrganization?.subscription)?.shortName) && !['drawingCustomArea', 'drawingProjectSurroundings', 'modifyingProjectSurroundings'].includes(this.props.currentAction),
                children: {
                    printPdfs: { icon: faFilePdf, title: i18n.t("Exporter toutes les fiches PDF avec aperçus"), isDisabledInOffline: true },
                    updateReferences: { icon: faCircleBookmark, title: i18n.t("Faire correspondre les références"), isDisabledInOffline: true },
                    updateSpwFields: { icon: faPenNib, title: i18n.t("Ajouter les dates/opérateurs terrain & mettre à jour le diamètre de couronne"), isDisabledInOffline: true },
                }
            }
        },
        selectedButtons: [],
        rightClickedButton: null,
        isToolbarExpanding: false,
        isToolbarExpanded: false,
        proFeaturesMissing: null
    };

    render() {
        const { isPreview, currentAction, isDarkTheme } = this.props;
        const { buttons, rightClickedButton, proFeaturesMissing, isToolbarExpanding } = this.state;
        const buttonName = rightClickedButton?.buttonName;
        const isButtonInFavorite = buttons.favoriteTools.children && buttonName && buttons.favoriteTools.children[buttonName] ? true : false;
        let className = isToolbarExpanding ? 'expanded' : '';
        if (['managingActionElements', 'managingEventElements', 'viewingWorkSite'].includes(currentAction)) className += 'managing-elements';

        return (
            <>
                <div id='toolbar' ref={this.toolbarElementRef} className={className} style={!isPreview ? { display: 'flex', flexDirection: 'column' } : { display: 'flex', flexDirection: 'column' }}>
                    <div className='toolbar-content' ref={this.toolbarContentRef}>
                        <div className='buttons'>{this.renderButtons(0, buttons)}</div>
                        <div>
                            <Button
                                title={!isToolbarExpanding ? i18n.t("Afficher les titres") : i18n.t("Masquer les titres")}
                                style={{ justifyContent: isToolbarExpanding ? 'left' : 'center', ...(isToolbarExpanding ? { paddingLeft: '9.5px' } : {}) }}
                                onClick={this.props.toggleToolbarExpand}
                            >
                                <FontAwesomeIcon icon={isToolbarExpanding ? faAnglesLeft : faAnglesRight} style={{ marginRight: isToolbarExpanding ? '10px' : '0' }} />
                            </Button>
                        </div>
                    </div>
                    <Menu id='toolbar-context-menu' theme={isDarkTheme ? 'dark' : 'light'} animation={false}>
                        <Item onClick={this.toggleFavorite}>
                            <span style={{ marginRight: '10px' }}>{isButtonInFavorite ? i18n.t("Retirer des favoris") : i18n.t("Ajouter aux favoris")}</span>
                            <FontAwesomeIcon icon={isButtonInFavorite ? faStar : faStarAlt} style={{ marginLeft: 'auto' }} />
                        </Item>
                    </Menu>
                </div>
                {proFeaturesMissing && <ProFeaturesButton feature={proFeaturesMissing} showButton={false} isDefaultOpen={true} onClose={() => this.setState({ proFeaturesMissing: null })} />}
            </>
        );
    };

    toolbarElementRef = React.createRef();
    toolbarContentRef = React.createRef();

    updateToolbarHeight = () => {
        const toolbarElement = this.toolbarElementRef.current;
        const contentElement = this.toolbarContentRef.current;
        if (!toolbarElement || !contentElement) return;

        const availableHeight = toolbarElement.parentElement.clientHeight - 10; // 5px de marge en haut + en bas
        const contentHeight = Math.ceil(contentElement.getBoundingClientRect().height);

        // La toolbar s'arrête juste au-dessus des outils flottants du bas de la carte (BaseLayersMenu, échelle)
        const baseLayersMenu = document.getElementById('base-layers-menu');
        const maxHeight = baseLayersMenu
            ? Math.min(availableHeight, baseLayersMenu.getBoundingClientRect().top - toolbarElement.getBoundingClientRect().top - 5)
            : availableHeight;

        toolbarElement.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden';
        toolbarElement.style.height = `${Math.min(contentHeight, maxHeight)}px`;
    }

    getToolContext = () => ({ project: this.props.project, rights: this.props.rights, activeOrganization: this.props.activeOrganization, publicFields: this.publicFields });

    componentDidMount = () => {
        this.publicFields = ProjectsUtil.getProjectPublicFields(this.props.project, this.props.projectCollaborators || []);
        this.setState({ isToolbarExpanding: this.props.isToolbarExpanded, isToolbarExpanded: this.props.isToolbarExpanded });

        this.toolbarResizeObserver = new ResizeObserver(() => window.requestAnimationFrame(this.updateToolbarHeight));
        this.toolbarResizeObserver.observe(this.toolbarContentRef.current);
        this.toolbarResizeObserver.observe(this.toolbarElementRef.current.parentElement);

        window.addEventListener('resize', this.handleFullScreenChange);
        if (this.props.favoriteTools?.length) {
            let favoriteToolsChildren = {};
            this.props.favoriteTools.forEach(favoriteTool => {
                let button = this.findButton(favoriteTool);
                if (button) {
                    while (button['button']) button = button['button'];
                    favoriteToolsChildren[favoriteTool] = button;
                }
            });
            this.setState(prevState => ({
                ...prevState, buttons: {
                    ...prevState.buttons,
                    favoriteTools: { ...prevState.buttons.favoriteTools, children: favoriteToolsChildren }
                }
            }));
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.projectCollaborators !== this.props.projectCollaborators || prevProps.project !== this.props.project || (!this.props.project && !this.publicFields))
            this.publicFields = ProjectsUtil.getProjectPublicFields(this.props.project, this.props.projectCollaborators || []);
        if (prevProps.isToolbarExpanded !== this.props.isToolbarExpanded) { // Permet d'attendre la fin de l'animation pour masquer les titres
            if (this.props.isToolbarExpanded) this.setState({ isToolbarExpanding: true, isToolbarExpanded: true });
            else this.setState({ isToolbarExpanding: false }, () => setTimeout(() => this.setState({ isToolbarExpanded: false }), 500));
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.handleFullScreenChange);
        Object.keys(this.props.buttonStates).forEach(buttonName => {
            if (this.props.buttonStates[buttonName]) this.props.setButtonState(buttonName, 0);
        });
        this.toolbarResizeObserver?.disconnect();
    }

    renderButtons = (index, buttons) => {
        const { selectedButtons, isToolbarExpanded } = this.state;
        if (selectedButtons.length > 1 && selectedButtons[0]) {
            const category = selectedButtons[0].name === 'treeTools' ? 'Arbre' : selectedButtons[0].name === 'greenSpaceTools' ? 'Espace vert' : 'BackgroundImage';
            if (selectedButtons[index - 1]?.name === 'remove' && this.props.selectedElements.filter(l => l.feature.properties.category === category).length) return;
        }

        const parentButton = selectedButtons[index - 1];
        const selectedButton = parentButton?.children && Object.values(parentButton.children).includes(selectedButtons[index]) ? selectedButtons[index] : null;

        return (
            <div id={`toolbar-category-${index}`} style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 'fit-content', maxWidth: '100%' }}>
                {index > 0 && <>
                    <Divider style={{ margin: '0', backgroundColor: 'var(--primary-100)', height: '3px', border: 'none' }} />
                    <div className='divider-pointer'></div>
                </>}
                {Object.keys(buttons).map(buttonName => {
                    const button = buttons[buttonName];
                    const buttonState = button.isReduxManaged ? this.props.buttonStates[buttonName] : button.state;
                    const title = button.states?.[buttonState]?.title || button.title;
                    const shortcut = button.states?.[buttonState]?.shortcut || button.shortcut;
                    const icon = button.icon || button.states?.[buttonState]?.icon;
                    const isActive = button.isActive || button.states?.[buttonState]?.isActive;
                    const isActivatedInSubscription = button.isActivatedInSubscription ? button.isActivatedInSubscription() : true;
                    const isLoading = button.isLoading && button.isLoading();

                    return (!button.isVisible || button.isVisible())
                        // Si le bouton a des enfants, il faut qu'au moins un de ceux-ci puisse être affiché pour render le parent
                        && (!button.children || Object.keys(button.children).some(childName => !button.children[childName].isVisible || button.children[childName].isVisible()))
                        && (
                            <Button
                                key={buttonName} id={button.id} title={`${title}${shortcut ? ` (${shortcut})` : ''}`}
                                className={`${(selectedButtons.includes(button) || isActive) ? 'active' : ''} ${button.className || ''}`}
                                style={{ position: 'relative', justifyContent: isToolbarExpanded ? 'left' : 'center', ...(isToolbarExpanded ? { paddingLeft: '9.5px' } : {}) }}
                                disabled={isLoading || button.isDisabled || (button.isDisabledInOffline && !this.props.isOnline && !isActive) || (parentButton?.onlyOne && selectedButton && selectedButton !== button)}
                                onClick={() => { this.handleButtonClick(index, buttonName, button) }} onContextMenu={(e) => this.handleContextMenu(e, index, buttonName, button)}
                            >
                                <FontAwesomeIcon icon={icon} style={{ opacity: isLoading ? 0.5 : 1 }} />
                                {isToolbarExpanded && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>}
                                {!isActivatedInSubscription && <FontAwesomeIcon icon={faLock} title={i18n.t("Upgradez votre licence pour débloquer cette fonctionnalité")} style={{ position: 'absolute', top: '1px', right: '3px', fontSize: '10px', color: 'var(--yellow-100)' }} />}
                                {isLoading &&
                                    <div style={{ position: 'absolute' }}>
                                        <Loader active inline size='tiny' inverted={this.props.isDarkTheme} />
                                    </div>}
                            </Button>);
                })}

                {selectedButtons[index]?.children && (!selectedButtons[index - 1] || Object.keys(selectedButtons[index - 1].children).some(buttonName => (
                    selectedButtons[index - 1].children[buttonName] === selectedButtons[index]
                ))) && this.renderButtons(index + 1, selectedButtons[index].children)}
            </div>
        );
    };

    handleButtonClick = (index, buttonName, button) => {
        if (button.isActivatedInSubscription && !button.isActivatedInSubscription()) {
            this.setState({ proFeaturesMissing: button.key });
            return;
        }

        if (button.isSelectable || button.children) {
            button.name = buttonName;
            this.setState(({ selectedButtons }) => {
                if (selectedButtons[index] === button && !selectedButtons[index - 1]?.atLeastOne) {
                    if (buttonName.includes('Tools')) delete selectedButtons[index];
                    else selectedButtons = selectedButtons.slice(0, index);
                } else {
                    selectedButtons[index] = button;
                    if (!buttonName.includes('Tools'))
                        selectedButtons = selectedButtons.slice(0, index + 1);
                    if (button.children) {
                        const defaultButtonName = Object.keys(button.children).find(buttonName => button.children[buttonName].isDefault);
                        if (defaultButtonName) {
                            button.children[defaultButtonName].name = defaultButtonName;
                            selectedButtons.push(button.children[defaultButtonName]);
                        }
                    }
                }

                return { selectedButtons };
            });
        }

        const buttonState = button.isReduxManaged ? this.props.buttonStates[buttonName] : button.state;
        if (!this.props.isPreview) this.props.handleToolbarButtonClick(buttonName, buttonState);

        if (button.states && (button.autoSwitch || button.states[buttonState].autoSwitch)) {
            button.state++;
            if (!button.states[button.state]) button.state = 0;
            this.setState(prevState => ({ buttons: prevState.buttons }));
        }
    }

    handleContextMenu = (event, index, buttonName, button) => {
        if (index === 1) {
            contextMenu.show({ event, id: 'toolbar-context-menu' });
            this.setState({ rightClickedButton: { buttonName, button } });
        }
    }

    toggleFavorite = () => {
        const { rightClickedButton, buttons, selectedButtons } = this.state;
        let favoriteTools = buttons.favoriteTools;
        favoriteTools.children = favoriteTools.children || {};
        if (favoriteTools.children[rightClickedButton.buttonName]) {
            delete favoriteTools.children[rightClickedButton.buttonName];
            showToast('favorite_tool_removed');
        } else {
            favoriteTools.children = { ...favoriteTools.children, [rightClickedButton.buttonName]: rightClickedButton.button };
            showToast('favorite_tool_added');
        }

        const index = selectedButtons.indexOf(buttons.favoriteTools);
        if (index !== -1) {
            selectedButtons.splice(index, 1);
            selectedButtons.push(favoriteTools);
        }

        this.setState(prevState => ({
            ...prevState, buttons: {
                ...prevState.buttons,
                favoriteTools
            }, rightClickedButton: null,
            selectedButtons
        }), () => {
            localStorage.setItem('favoriteTools', JSON.stringify(Object.keys(favoriteTools.children)));
            this.props.setFavoriteTools(Object.keys(favoriteTools.children));
        });
    }

    findButton = (buttonName) => {
        let index = -1, buttonPath;
        const findButton = (buttons, path = []) => {
            if (!button) {
                Object.keys(buttons).forEach(name => {
                    const newPath = [...path, name];
                    if (name === buttonName) {
                        index = newPath.length - 1;
                        buttonPath = newPath;
                        button = buttons[name];
                    } else if (buttons[name].children)
                        findButton(buttons[name].children, newPath);
                });
            }
        };

        let button;
        findButton(this.state.buttons);
        return { index, path: buttonPath, button };
    }

    clickButton = (buttonName) => { // Utilisé uniquement pour les boutons pas gérés par Redux
        const { buttons, selectedButtons } = this.state;

        const { path } = this.findButton(buttonName);
        let index = 0;

        const clickButton = (button) => {
            if (button.isDisabled || (button.isVisible && !button.isVisible())) return;
            if (!selectedButtons.includes(button) && !(button.isActive || button.states?.[button.state]?.isActive))
                this.handleButtonClick(index, path[index], button);
            index++;
            if (path[index] && button.children) setTimeout(() => clickButton(button.children[path[index]]), 100); // Sans le timeout certaines actions sont trop rapides
        }

        if (path?.[0]) clickButton(buttons[path[0]]);
    }

    setButtonState = (buttonName, state, oldState = null) => {
        const { button } = this.findButton(buttonName);
        if ((oldState === null || button.state === oldState) && button?.states?.[state]) {
            button.state = state;
            this.setState(prevState => ({ buttons: prevState.buttons }));
            return true;
        }
        return false;
    }

    setButtonsIsDisabled = (buttonNames, isDisabled) => {
        buttonNames.forEach(buttonName => {
            const { button } = this.findButton(buttonName);
            if (button) button.isDisabled = isDisabled;
        });

        this.setState(prevState => ({ buttons: prevState.buttons }));
    }

    isButtonClickable = (buttonName) => {
        const { buttons } = this.state;
        const { path } = this.findButton(buttonName);
        let button, isClickable = true;
        for (buttonName of path) {
            button = button ? button.children[buttonName] : buttons[buttonName];
            if (button.isDisabled || (button.isVisible && !button.isVisible())) isClickable = false;
        }
        return isClickable;
    }

    setButtonsIsVisible = (buttonNames, isVisible) => {
        buttonNames.forEach(buttonName => {
            const { button } = this.findButton(buttonName);
            if (button) button.isVisible = () => isVisible;
        });

        this.setState(prevState => ({ buttons: prevState.buttons }));
    }

    resetButtonSelection = (index) => {
        this.setState(({ selectedButtons }) => {
            selectedButtons = selectedButtons.slice(0, index);
            return { selectedButtons };
        });
    }

    handleFullScreenChange = () => {
        if (this.props.buttonStates.fullscreen !== 0 && window.screen.height > window.innerHeight)
            this.setState(({ buttons }) => {
                this.props.buttonStates.fullscreen = 0;
                return buttons;
            });
    }
}

const mapStateToProps = (state) => {
    return {
        isDarkTheme: state.isDarkTheme,
        rights: state.rights,
        project: state.project,
        projectCollaborators: state.projectCollaborators,
        activeOrganization: state.activeOrganization,
        buttonStates: state.buttonStates,
        favoriteTools: state.favoriteTools,
        isToolbarExpanded: state.isToolbarExpanded,
        isOnline: state.isOnline,
        currentAction: state.currentAction,
        baseProjectDataLoadingStatus: state.baseProjectDataLoadingStatus
    };
}

const mapDispatchToProps = {
    setButtonState,
    setFavoriteTools,
    toggleToolbarExpand
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Toolbar);